import { baseServiceInvoiceSchema } from "@redotech/redo-billing-common/service-invoice";
import * as z from "zod";

export const getFinalizedImsForecastingInvoices = {
  name: "getFinalizedImsForecastingInvoices" as const,
  input: z.null(),
  output: z.array(baseServiceInvoiceSchema),
};
